import React from "react";
import PropTypes from "prop-types";
import { Text, Stack, TextLink } from "@chaser/components";
import { formatDate } from "../../../../../util/time";

const getTrialModuleTitle = (module) => {
  const moduleLabel = module?.moduleName || "Module";
  return moduleLabel;
};

const getTrialEndLabelForModule = (module) => {
  const trialEndDate = module?.trialEndsAt
    ? new Date(module.trialEndsAt)
    : null;
  if (!trialEndDate || Number.isNaN(trialEndDate.getTime())) {
    return "Trial";
  }

  return `Trial ends ${formatDate(trialEndDate, { month: "long" })}`;
};

const TrialModulesSection = ({
  trialModules,
  moduleSummaryIds,
  onOpenModule,
  style,
}) => {
  if (!trialModules.length) return null;

  return (
    <Stack className={style.trialModulesBox}>
      <Text fontSize="small">MODULES IN TRIAL</Text>
      <div className={style.trialModulesList}>
        {trialModules.map((module) => (
          <div key={module.id} className={style.trialModuleRow}>
            <Stack gap="xsmall">
              {moduleSummaryIds.has(module.id) ? (
                <TextLink monochrome onClick={() => onOpenModule(module.id)}>
                  {getTrialModuleTitle(module)}
                </TextLink>
              ) : (
                <Text>{getTrialModuleTitle(module)}</Text>
              )}
              <Text color="Mid Neutral 1" className={style.lineSubtitle}>
                {getTrialEndLabelForModule(module)}
              </Text>
            </Stack>
            <span className={style.statusPill}>Trial</span>
          </div>
        ))}
      </div>
    </Stack>
  );
};

TrialModulesSection.propTypes = {
  trialModules: PropTypes.arrayOf(PropTypes.object).isRequired,
  moduleSummaryIds: PropTypes.instanceOf(Set).isRequired,
  onOpenModule: PropTypes.func.isRequired,
  style: PropTypes.object.isRequired,
};

export default TrialModulesSection;
